import {configureStore} from '@reduxjs/toolkit'
import counterReducer from '../src/reduxSlices/counter/counterSlice'
import filesReducer from '../src/reduxSlices/files/filesSlice'
import configReducer from '../src/reduxSlices/configuration/configSlice'
import resultsReducer from '../src/reduxSlices/results/resultsSlice'
import authReducer from '../src/reduxSlices/auth/authSlice'

const store = configureStore({
    reducer:{
        // counter: counterReducer,
        // files: filesReducer,
        // configuration: configReducer,
        results: resultsReducer,
        auth: authReducer,
    },
})

export default store;